var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h360v360H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.755 235.21c-9.192 10.68-20.907 18.916-30.456 29.279-9.547 10.365-17.086 24.085-14.955 38.012 2.894 18.907 22.763 34.435 20.144 52.792a23.917 23.917 0 0 1-.427 2.225c-.17.7-.372 1.388-.606 2.059H57.245a61.954 61.954 0 0 1-5.722-4.284c-6.137-5.17-11.56-11.79-16.05-20.264-10.755-20.297-10.824-45.892-.174-66.246 11.405-21.794 34.463-39.023 35.256-63.606.647-20.04-14.362-38.435-12.394-58.387 1.05-10.612 7.22-20.598 16.243-26.28 9.022-5.683 20.696-6.936 30.719-3.297 7.524 2.73 14.087 8.017 21.93 9.632 12.813 2.64 25.412-5.102 35.223-13.756 8.735-7.702 16.58-16.422 25.806-23.532C197.31 82.45 208.35 76.921 219.996 77c11.646.082 23.736 6.952 27.217 18.067 3.142 10.026-1.011 20.97.619 31.352 2.332 14.855 16.03 25.481 30.183 30.56 14.152 5.079 29.45 6.178 43.761 10.796 14.309 4.616 28.514 14.152 32.278 28.71 3.53 13.642-3.106 28.045-12.3 38.725",
    fill: "#E5E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 357.327c0 .62-.203 1.183-.531 1.59-.257.32-.59.543-.964.624a1.352 1.352 0 0 1-.317.036H38.812c-1 0-1.812-1.008-1.812-2.25 0-.623.203-1.186.531-1.59.328-.408.781-.66 1.281-.66h286.375c.11 0 .214.011.318.036.85.184 1.495 1.105 1.495 2.214",
    fill: "#84A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.856 133.848v207.277H143.871V133.848c0-5.627-4.56-10.194-10.188-10.194h135.98v.002l.003-.002c5.63 0 10.19 4.567 10.19 10.194",
    fill: "#E5E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.732 133.848V340H144.996V133.848c0-3.706-1.79-7.002-4.551-9.07h9.785l114.57.011h5.305c4.795.23 8.627 4.206 8.627 9.059",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.982 333.25H151.749l-.106-199.4c0-3.368-1.935-7.121-4.844-9.072h3.431c2.28 2.47 3.663 5.873 3.663 9.07L153.996 331h115.736l-.106-197.15c0-3.361-1.928-7.105-4.826-9.06h3.422c2.275 2.47 3.654 5.865 3.654 9.058l.106 199.402z",
    fill: "#84A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.872 133.85h-20.385c0-5.629 4.562-10.195 10.195-10.195 5.628 0 10.19 4.566 10.19 10.194",
    fill: "#050F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.078 160.478h20.965v-20.965h-20.965v20.965zm-2.145 2.145h25.255v-25.255h-25.255v25.255z",
    fill: "#84A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#155BCD",
    d: "M195.845 143.083h62.606v-2.145h-62.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84A9FF",
    d: "M195.845 151.068h62.606v-2.145h-62.606zM195.845 159.053h44.007v-2.145h-44.007zM168.078 192.695h20.965v-20.966h-20.965v20.966zm-2.145 2.145h25.255v-25.255h-25.255v25.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#155BCD",
    d: "M195.845 175.3h62.606v-2.145h-62.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84A9FF",
    d: "M195.845 183.285h62.606v-2.145h-62.606zM195.845 191.27h44.007v-2.146h-44.007zM168.078 224.911h20.965v-20.965h-20.965v20.965zm-2.145 2.145h25.255v-25.255h-25.255v25.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#155BCD",
    d: "M195.845 207.516h62.606v-2.145h-62.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84A9FF",
    d: "M195.845 215.501h62.606v-2.145h-62.606zM195.845 223.486h44.007v-2.145h-44.007zM168.078 257.127h20.965v-20.965h-20.965v20.965zm-2.145 2.146h25.255v-25.256h-25.255v25.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#155BCD",
    d: "M195.845 239.733h62.606v-2.145h-62.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84A9FF",
    d: "M195.845 247.717h62.606v-2.145h-62.606zM195.845 255.702h44.007v-2.145h-44.007zM168.078 289.344h20.965v-20.965h-20.965v20.965zm-2.145 2.145h25.255v-25.255h-25.255v25.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#155BCD",
    d: "M195.845 271.95h62.606v-2.146h-62.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84A9FF",
    d: "M195.845 279.934h62.606v-2.145h-62.606zM195.845 287.918h44.007v-2.145h-44.007zM168.078 321.56h20.965v-20.965h-20.965v20.965zm-2.145 2.145h25.255V298.45h-25.255v25.255z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#155BCD",
    d: "M195.845 304.166h62.606v-2.145h-62.606z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84A9FF",
    d: "M195.845 312.15h62.606v-2.145h-62.606zM195.845 320.135h44.007v-2.145h-44.007z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050F64",
    d: "M123.487 158.26h20.384v-24.41h-20.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF654F",
    d: "M171.776 153.045h13.57v-9.868h-13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA5544",
    d: "M185.346 153.045v3.77l-5.346-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.146 148.49 2.374 2.406 2.407-2.374c2.09-2.06-.284-4.468-2.374-2.407-2.031-2.06-4.438.314-2.407 2.374",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF654F",
    d: "M171.776 185.262h13.57v-9.87h-13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA5544",
    d: "M185.346 185.262v3.769l-5.346-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.146 180.706 2.374 2.407 2.407-2.374c2.09-2.061-.284-4.468-2.374-2.407-2.031-2.06-4.438.314-2.407 2.374",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF654F",
    d: "M171.776 217.746h13.57v-9.868h-13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA5544",
    d: "M185.346 217.746v3.77l-5.346-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.146 213.19 2.374 2.407 2.407-2.373c2.09-2.062-.284-4.469-2.374-2.408-2.031-2.06-4.438.314-2.407 2.374",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF654F",
    d: "M171.776 249.838h13.57v-9.868h-13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA5544",
    d: "M185.346 249.838v3.77l-5.346-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.146 245.282 2.374 2.407 2.407-2.374c2.09-2.06-.284-4.468-2.374-2.407-2.031-2.06-4.438.314-2.407 2.374",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF654F",
    d: "M171.776 281.911h13.57v-9.869h-13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA5544",
    d: "M185.346 281.911v3.77L180 281.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.146 277.355 2.374 2.407 2.407-2.374c2.09-2.061-.284-4.468-2.374-2.407-2.031-2.06-4.438.314-2.407 2.374",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF654F",
    d: "M171.776 314.127h13.57v-9.868h-13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA5544",
    d: "M185.346 314.127v3.77l-5.346-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.146 309.571 2.374 2.407 2.407-2.373c2.09-2.062-.284-4.469-2.374-2.407-2.031-2.06-4.438.313-2.407 2.373",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF654F",
    d: "M97.702 211.526h33.727v-24.529H97.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA5544",
    d: "M131.43 211.526v9.369l-13.287-9.369z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.564 200.202 5.9 5.982 5.983-5.9c5.195-5.123-.705-11.106-5.9-5.983-5.05-5.12-11.032.78-5.983 5.9",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050F64",
    d: "m128.062 223.732-2.542 11.205-1.117.06 2.54-11.205z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#155BCD",
    d: "m134.327 223.396-2.541 11.205-6.265.336 2.54-11.205z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.414 251.288c.458.618.39 1.456-.157 1.912-1.616 1.348-3.263 2.675-5.009 3.926-1.746 1.251-3.573 2.447-5.663 3.433-1.046.49-2.168.923-3.417 1.208-1.238.289-2.637.41-4.082.193-1.445-.212-2.88-.802-4.052-1.592-1.188-.788-2.14-1.73-2.96-2.683-.824-.957-1.505-1.94-2.129-2.924a44.257 44.257 0 0 1-1.698-2.956c-1.038-1.972-1.942-3.94-2.803-5.898-1.715-3.92-3.262-7.81-4.82-11.67-.927-2.472.595-5.263 3.343-6.153 2.75-.89 5.622.51 6.302 3.06.982 4.04 1.942 8.062 3.011 11.962.537 1.947 1.104 3.863 1.747 5.686.322.91.664 1.795 1.035 2.633.371.836.77 1.633 1.205 2.326.434.696.898 1.299 1.381 1.746.485.456.976.763 1.566.965 1.167.41 2.894.254 4.66-.291 1.775-.534 3.592-1.36 5.376-2.285 1.789-.923 3.554-1.964 5.306-3.038.586-.371 1.4-.178 1.858.44",
    fill: "#EA8096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.74 246.764-3.933-11.106c-1.19-3.36-.08-6.925 2.762-7.932 2.842-1.006 6.342.927 7.532 4.287l3.933 11.106-10.294 3.645z",
    fill: "#84A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.683 344.808s-.01 2.942 1.37 5.328l-6.076-4.581.259-.757s.996-.725 1.792-1.857l2.655 1.867z",
    fill: "#F5BDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.412 346.675 7.95 5.59c.293.206.665-.114.507-.434l-1.696-3.416c-.221-.255-.489-.187-.685.019a.475.475 0 0 1-.615.055l-3.188-2.227a2.878 2.878 0 0 1-.94-1.102l-.265-.544a.204.204 0 0 0-.35-.028l-.867 1.233a.613.613 0 0 0 .149.854",
    fill: "#050F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.445 349.735s1.367 2.605 3.703 4.068l-7.512-1.207-.126-.79s.542-1.106.715-2.48l3.22.409z",
    fill: "#F5BDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.66 353.851 9.642 1.222c.354.045.534-.413.244-.621l-3.097-2.226c-.314-.122-.519.063-.596.337a.475.475 0 0 1-.517.337l-3.86-.477a2.88 2.88 0 0 1-1.347-.534l-.489-.358a.204.204 0 0 0-.322.14l-.19 1.494a.613.613 0 0 0 .532.686M97.919 267.162l.001-.001c.191-4.27 14.708-7.297 14.517-3.026l1.216 34.568a41.705 41.705 0 0 1-.192 4.372l-4.528 46.881-3.45-.445-3.566-47.94c-4.938-8.84-5.703-20.723-3.998-34.41",
    fill: "#050F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.174 300.57c-4.318-8.83-4.738-20.382-2.816-33.57l.002.001V267a7.74 7.74 0 1 1 15.447 1.015v.009s-.397 32.918-.407 33.087v.05h-.003a5.87 5.87 0 0 1-.724 2.474l-.005.008c-.09.16-26.895 41.306-26.895 41.306l-2.854-1.991 18.255-42.388z",
    fill: "#050F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.932 277.992.386-.018c.127-3.503.486-7.171 1.041-10.974.008-.127.02-.252.035-.378h-.388a9.485 9.485 0 0 0-.029.326c-.573 3.93-.922 7.608-1.045 11.044zM76.32 343.937l-.21.322 1.769 1.235 6.723-10.322-.29-.262-6.54 10.04-1.452-1.013zm-.183-3.805 17.037-39.562a34.02 34.02 0 0 1-2.141-5.635l-.375.09a34.488 34.488 0 0 0 2.092 5.555l-16.993 39.456.38.096zm18.486-21.045.266.3 10.121-15.564a6.229 6.229 0 0 0 .741-2.29s.046-.762.04-.942l.35-28.287-.389-.004-.352 28.86h-.004a5.85 5.85 0 0 1-.723 2.476l-.004.007c-.09.16-.19.317-.293.473l-.027.037h.003l-9.729 14.934z",
    fill: "#155BCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.41 225.49s-7.54.474-8.381-8.708c0 0 3.636-2.016 3.875-2.085.24-.069 4.258 6.214 4.258 6.214l.248 4.58z",
    fill: "#050F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75 225.3c8.769-.642 16.056 6.666 15.388 15.433l-1.701 23.402c-6.1 2.804-14.35 3.088-21.76 1.595l-2.817-26.765c-1.05-6.859 3.969-13.157 10.89-13.664",
    fill: "#84A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.624 225.684-.053.387c5.917 2.081 10.078 7.943 9.567 14.663l-1.318 18.143.391-.071 1.312-18.045a14.755 14.755 0 0 0-4.266-11.545 14.756 14.756 0 0 0-5.633-3.532zM87.972 243.7l2.35 22.353.279.055c1.445.292 2.912.514 4.376.662l-.002-.387a45.313 45.313 0 0 1-4.298-.654l-2.32-22.051-.385.022z",
    fill: "#E5E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.56 222.198-1.67 8.662c-2.116.859-3.997.496-5.643-1.088l1.67-8.661 5.643 1.087z",
    fill: "#F5BDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.41 222.983-.415 2.148a6.273 6.273 0 0 1-3.21.282 3.822 3.822 0 0 1-2.4-1.536l.38-1.982 5.644 1.088z",
    fill: "#EA8096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.472 214.495-1.093 5.021-.243 1.114a5.466 5.466 0 0 1-6.107 4.198 3.082 3.082 0 0 1-1.13-.397l-.061-.037a2.98 2.98 0 0 1-.946-.92c-.535-.83-.826-1.686-1.076-2.565-.218-.768-.405-1.521-.502-2.273-.116-.894-.104-1.788.131-2.708l.643-1.834 2.391-2.106 6.732.09 1.26 2.417z",
    fill: "#F5BDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.72 211.803c.108-.14.216-.265.323-.382a2.276 2.276 0 0 1-1.033-.932c-.76-1.331.032-3.215 1.77-4.206 1.736-.99 3.76-.714 4.52.618.32.562.362 1.223.175 1.874 3.619-.778 6.337 2.562 6.69 4.593.407 2.346-.188 4.366-.188 4.366 1.047.667.971 3.823-.821 4.584-2.29.972-1.205 3.246-1.205 3.246-.855-.812-1.121-2.869.216-3.804.905-.634 1.793-1.319 1.193-2.52-.358-.717-.668-1.495-1.04-2.302-.692-1.502-2.078-2.586-3.71-2.855l-.036-.006c-2.354-.379-2.918-1.34-3.053-1.815-.435.53-.788 1.208-1.069 1.888.047.17.114.343.204.52 1.621 3.147-2.4 6.841-2.4 6.841s2.829-3.23 1.64-5.73c-.206.728-.3 1.248-.3 1.248.15 2.198-2.316 2.095-2.947 1.344-1.513-1.801.01-5.191 1.07-6.57",
    fill: "#050F64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.191 217.301a2.091 2.091 0 1 1-4.106-.792 2.091 2.091 0 0 1 4.106.792M130.989 225.33c.764.082 1.334.7 1.299 1.411-.105 2.102-.246 4.212-.51 6.344-.264 2.131-.624 4.286-1.316 6.49-.348 1.101-.791 2.22-1.429 3.33-.626 1.107-1.485 2.218-2.625 3.133-1.135.918-2.54 1.573-3.917 1.899-1.384.34-2.722.401-3.98.358-1.261-.044-2.446-.21-3.591-.418a44.278 44.278 0 0 1-3.325-.756c-2.153-.574-4.212-1.243-6.236-1.938-4.043-1.396-7.952-2.896-11.847-4.369-2.445-.994-3.465-4.004-2.256-6.628 1.21-2.624 4.187-3.787 6.522-2.558 3.635 2.016 7.243 4.037 10.834 5.895 1.796.926 3.588 1.809 5.365 2.572.887.38 1.77.728 2.637 1.023.866.294 1.722.542 2.526.691.806.153 1.564.221 2.22.17.664-.049 1.223-.201 1.772-.498 1.093-.58 2.148-1.955 2.945-3.623.81-1.667 1.435-3.563 1.965-5.5.533-1.942.965-3.945 1.363-5.96.125-.683.82-1.152 1.584-1.069",
    fill: "#F5BDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.512 246.282-10.83-4.639c-3.277-1.403-5.146-4.635-3.959-7.407 1.187-2.772 4.981-4.034 8.257-2.631l10.831 4.638-4.299 10.039z",
    fill: "#84A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.53 241.997.569.244.138-.36-.555-.238c-3.25-1.393-5.115-4.584-3.985-7.339l-.335-.206c-1.232 2.904.595 6.37 4.168 7.9zm6.245 2.675 4.941 2.117 4.603-10.748-4.084-1.75-.133.364 3.71 1.59-4.3 10.037-4.572-1.959-.165.349z",
    fill: "#E5E6EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistEmpty);
export default __webpack_public_path__ + "static/media/wishlist-empty.410849715672874df06b1e4f9b128de3.svg";
export { ForwardRef as ReactComponent };